module.exports = __webpack_public_path__ + "img/git_loader.8264c9b1.gif";